import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'v2m-benefit',
  templateUrl: './benefit.component.html',
  styleUrls: ['./benefit.component.scss']
})
export class BenefitComponent implements OnInit, AfterViewInit {
  images = ['url(assets/teaser_nutzen.jpg)'];
  fragment: string;

  constructor(private route: ActivatedRoute, private seo: SeoService) {}

  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
    });
    this.seo.updateTitle('video2manual - Nutzen und Vorteile');
    this.seo.updateKeywords(
      'Optimale Wissensvermittlung, Unternehmens-Entwicklung'
    );
  }

  ngAfterViewInit(): void {
    try {
      document.querySelector('#' + this.fragment).scrollIntoView();
    } catch (e) {}
  }

  scrollToTarget($element): void {
    $element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }
}
